import * as actionTypes from "../Actions/ContactsActionTypes";
import LogService from "../../CommonSdk/LogService";

const LOG_TAG = "REDUCER:CONTACTS";

const initialState = {
    user: null,
    contacts: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.CONTACTS_CLEAR:
            LogService.info(LOG_TAG, "reduce", "" + action.type);

            return {
                ...initialState
            };

        case actionTypes.CONTACTS_SET_USER:
            LogService.info(LOG_TAG, "reduce", "" + action.type);

            return {
                ...state,
                user: action.payload.user
            };

        case actionTypes.CONTACTS_UPDATE:
            LogService.info(LOG_TAG, "reduce", "" + action.type);

            let updatedContactList = [...state.contacts];
            action.payload.contacts.forEach(element => {
                updatedContactList = updatedContactList.filter(contact => contact.id !== element.id);
                if (element.id !== state.user?.id) {
                    updatedContactList.push(element);
                }
            });

            return {
                ...state,
                contacts: updatedContactList
            };

        default:
            return state;
    }
}
